import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  type AffiliateCommissionRow,
  formatCommissionAmount,
  maskReferredUserId,
} from "@/lib/affiliateDashboard";
import type { OverrideAction } from "./AffiliateLedgerCard";
import { ACTION_LABEL, ACTION_NEEDS_NOTES } from "./overrideActions";

type Props = {
  row: AffiliateCommissionRow | null;
  action: OverrideAction;
  notes: string;
  setNotes: (v: string) => void;
  running: boolean;
  onClose: () => void;
  onRun: () => void;
};

export function AffiliateOverrideDialog({
  row,
  action,
  notes,
  setNotes,
  running,
  onClose,
  onRun,
}: Props) {
  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{ACTION_LABEL[action]} commission</DialogTitle>
          <DialogDescription>
            {row
              ? `${formatCommissionAmount(
                  row.commission_amount_cents,
                  row.currency,
                )} for ${maskReferredUserId(row.affiliate_user_id)}`
              : null}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label htmlFor="notes">
            Notes{ACTION_NEEDS_NOTES[action] ? " (required)" : " (optional)"}
          </Label>
          <Textarea
            id="notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder={
              action === "mark_paid"
                ? "Stripe transfer id, wire reference, etc."
                : action === "forfeit"
                  ? "Why is this being forfeited?"
                  : "Optional context"
            }
            rows={3}
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onRun} disabled={running}>
            {running ? "Applying…" : ACTION_LABEL[action]}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
